import { useEffect, useRef, useState } from "react";

import dayjs from "dayjs";
import useAppDispatch from "hooks/useAppDispatch";
import { getUserInfo } from "utils";
import { BEDWETTING_TYPE_VALUE } from "../constants";
import CalendarInfo from "./CalendarInfo";
import CalendarUrine from "./CalendarUrine";
import { Row, Col } from "antd";
import "./styles.scss";
import Loading from "components/loading/Loading";

const GraphCalendar = ({ dateSelected, setDateSelected, patientId, treatmentDate }) => {
  const [calendarData, setCalendarData] = useState({});
  const [selectData, setSelectData] = useState({});
  const printRef = useRef();

  const {
    data: {
      graphUrine: { data },
    },
    actions: { actGetGraphUrine },
  } = useAppDispatch("graph");

  useEffect(() => {
    let userInfo = getUserInfo();
    if (userInfo) {
      fetchData(dayjs(dateSelected));
    }
  }, []);

  useEffect(() => {
    if (data) {
      const dataFormat = data?.reduce((acc, current) => {
        const icons = [];

        if (
          current.bed_wetting_type ===
          BEDWETTING_TYPE_VALUE.the_alarm_went_off_and_I_woke_up_to_stop_it
            .value
        ) {
          icons.push("/icons/blueWater1.webp");
        }

        if (
          current.bed_wetting_type ===
          BEDWETTING_TYPE_VALUE
            .the_alarm_went_off_but_I_couldnt_wake_up_by_myself.value
        ) {
          icons.push("/icons/blueWater.webp");
        }

        if (
          !current.is_bed_wetting
        ) {
          icons.push("/icons/medal.webp");
        }

        if (current.memo_type === 2) {
          icons.push("/icons/toilet.webp");
        }

        if (current.is_take_medication) {
          icons.push("/icons/medicine.webp");
        }

        acc[dayjs(current.time).format("YYYY-MM-DD")] = {
          ...current,
          icons,
        };

        return acc;
      }, {});
      setCalendarData(dataFormat);
    }
  }, [data]);

  useEffect(() => {
    const dataSelect = calendarData?.[dateSelected.format("YYYY-MM-DD")];
    if (dateSelected && dataSelect) {
      setSelectData(dataSelect);
    } else {
      setSelectData({});
    }
  }, [dateSelected, calendarData]);

  const fetchData = (date) => {
    actGetGraphUrine({
      id: patientId,
      params: {
        from: dayjs(date)
          .startOf("month")
          .add(-13, 'day')
          .startOf("day")
          .utc()
          .format("YYYY-MM-DD hh:mm"),
        to: dayjs(date)
          .endOf("month")
          .add(13, 'day')
          .endOf("day")
          .utc()
          .format("YYYY-MM-DD hh:mm"),
      },
    });
  };

  return (
    <div className="home-right-content grap-calendar-container stacked-calendar" ref={printRef}>
      <div className="calendar-block">
        <CalendarUrine
          data={calendarData}
          dateSelected={dateSelected}
          setDateSelected={setDateSelected}
          fetchData={fetchData}
        />
      </div>
      <div className="calendar-block">
        <CalendarInfo
          selectData={selectData}
          dateSelected={dateSelected}
          setDateSelected={setDateSelected}
          fetchData={fetchData}
          patientId={patientId}
          treatmentDate={treatmentDate}
          element={printRef}
        />
      </div>
    </div>
  );
};
export default GraphCalendar;
